<script>
  import RetryPage from "../../../Shared/retryPage.svelte"
  import Progress from "../../../Shared/progress.svelte"
  import { push } from "svelte-spa-router"
  import { createEventDispatcher } from "svelte"
  const dispatch = createEventDispatcher()

  /**
   * @type {Object} stores the query value in the current url location
   */
  export let query
  /**
   * @type {string} name of the start button based on the condition
   */
  export let startBtnName
  /**
   * @type {"start"|"processing"|"completed"|"retry"} active item in document status tab
   */
  export let activeDoc
  /**
   * @type {Number} width of the progress bar
   */
  export let width
</script>

{#if activeDoc == "start"}
  <div class="mt-6 flex w-full justify-center text-center text-base text-gray-400 mobile:w-1/2">
    {#if startBtnName == "Send Email"}
      <h1>To initiate the procedure, press the 'Send Email' button for email transmission.</h1>
    {:else}
      <h1>To proceed with the process, simply click the 'Resume' button to initiate the transmission of the remaining emails.</h1>
    {/if}
  </div>
  <div class="mt-6 flex gap-3">
    <button
      on:click={() => {
        push(`/documents/bulk/view-report?id=${query.id}`)
      }}
      type="button"
      class="flex h-9 items-center justify-center rounded-md border border-[#a0a1a580] bg-blue-500 px-2 text-sm font-medium text-white hover:bg-blue-600 hover:text-white focus:outline-none active:bg-blue-500 disabled:cursor-not-allowed lg:px-4"
    >
      <span>
        <i class="fa-solid fa-eye" />
      </span>
      <span class="select-none">&nbsp;&nbsp;View&nbsp;Report&nbsp;</span>
    </button>
    <button on:click type="button" class="flex h-9 {startBtnName == 'Send Email' ? 'bg-green-500 hover:bg-green-600 active:bg-green-500 disabled:bg-green-500/50' : 'bg-blue-500 hover:bg-blue-600 active:bg-blue-500 disabled:bg-blue-500/50'} items-center justify-center rounded-md border border-[#a0a1a580] px-2 text-sm font-medium text-white hover:text-white focus:outline-none disabled:cursor-not-allowed lg:px-4">
      <span>
        <i class="fa-solid fa-circle-play" />
      </span>
      <span class="select-none">&nbsp;&nbsp;{startBtnName == "Send Email" ? "Send Email" : "Resume"}&nbsp;</span>
    </button>
  </div>
{:else if activeDoc == "processing"}
  <Progress {width} content="Transmitting Emails" />
{:else if activeDoc == "completed"}
  <div class="mt-12 flex w-full flex-col items-center justify-center gap-3 text-center text-3xl font-bold text-green-500 mobile:w-1/2 mobile:flex-row">
    <i class="fa-solid fa-circle-check" />
    <h1 class="text-2xl">Process Completed</h1>
  </div>
  <div class="mt-6 flex w-full justify-center text-center text-base text-gray-400 mobile:w-1/2">
    <h1>The emails have been effectively sent.</h1>
  </div>
  <div class="mt-6 flex w-full justify-center gap-3">
    <button
      on:click={() => {
        dispatch("redirect")
      }}
      type="button"
      class="normal-blue-btn disabled:text-white-200/50 disabled:cursor-not-allowed disabled:bg-blue-200/50"
    >
      <span><i class="fa-solid fa-eye" /></span>
      <span class="select-none">&nbsp;&nbsp;View&nbsp;Report&nbsp;</span>
    </button>
  </div>
{:else}
  <RetryPage content="A few documents encountered failures during the transmitting email process. Please consider retrying to proceed.">
    <button
      on:click={() => {
        push(`/documents/bulk/view-report?id=${query.id}`)
      }}
      type="button"
      class="flex h-9 items-center justify-center rounded-md border border-[#a0a1a580] bg-blue-500 px-2 text-sm font-medium text-white hover:bg-blue-600 hover:text-white focus:outline-none active:bg-blue-500 disabled:cursor-not-allowed lg:px-4"
    >
      <span>
        <i class="fa-solid fa-eye" />
      </span>
      <span class="select-none">&nbsp;&nbsp;View&nbsp;Report&nbsp;</span>
    </button>
  </RetryPage>
{/if}

<style lang="postcss">
  .normal-blue-btn {
    @apply flex h-9 items-center justify-center rounded-md border border-[#a0a1a580] bg-blue-500 px-4 text-sm font-medium text-white hover:bg-blue-600 hover:text-white focus:outline-none active:bg-blue-500;
  }
</style>
